import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { LbnActionButtonComponent } from "../../../shared/components/lbn-action-button/lbn-action-button.component";
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-table-controls',
  standalone: true,
  imports: [CommonModule, LbnActionButtonComponent, MatIconModule, ReactiveFormsModule],
  templateUrl: './table-controls.component.html',
  styleUrl: './table-controls.component.scss',
})
export class TableControlsComponent implements OnInit{
  @Input() data: any;
  @Output() event = new EventEmitter<{ value?: string; action: string }>();
 


  form!: FormGroup;
  lastSuccessfulQuery ='';
  // control visibility of icons
  searchIconVisible = true;
  clearIconVisible = false;

  constructor(private fb: FormBuilder) { }

  ngOnInit(): void {
    this.form = this.fb.group({
      searchControl: [''],
      appointmentStatuses: ['']
    });
  }
  onEnterPressed(){
    const searchValue = this.form.get('searchControl')?.value;
    // only perform search and switch icons if user entered characters
    if (searchValue && String(searchValue).trim() !== '') {
      this.lastSuccessfulQuery = String(searchValue);
      this.searchIconVisible = false;
      this.clearIconVisible = true;
      this.event.emit({action: "search", value:searchValue});
    }
  }

  onSearchIconClick(){
    const searchValue = this.form.get('searchControl')?.value;
    // Only toggle icons when there is input
    if (searchValue && String(searchValue).trim() !== '') {
      this.lastSuccessfulQuery = String(searchValue);
      this.searchIconVisible = false;
      this.clearIconVisible = true;
      this.event.emit({action: "search", value:searchValue});
    }
    // if no input, keep search icon visible and do nothing
  }

  onClearSearch(): void {
    this.form.get('searchControl')?.reset();
    this.searchIconVisible = true;
    this.clearIconVisible = false;
    this.event.emit({action: "clear", value: ''});
  }

  clickEvent(label:any){
    this.event.emit({action:label});
  }

  handleSelectionChange(){
    const selectedValue = this.form.get('appointmentStatuses')?.value;
    this.event.emit({action: "status", value: selectedValue});
  }

  resetControls(): void {
    this.form.get('searchControl')?.reset();
    this.form.get('appointmentStatuses')?.reset();
  }
}
